import { css } from 'styled-components';

import NotoSansSCBoldWoff from './zh/NotoSansSCBold-subset.woff';
import NotoSansSCBoldWoff2 from './zh/NotoSansSCBold-subset.woff2';
import NotoSansSCWoff from './zh/NotoSansSCRegular-subset.woff';
import NotoSansSCWoff2 from './zh/NotoSansSCRegular-subset.woff2';
import SSPBold from './en/SourceSansProBold.ttf';
import SSPExtraLight from './en/SourceSansProExtraLight.ttf';
import SSPItalic from './en/SourceSansProItalic.ttf';
import SSPLight from './en/SourceSansProLight.ttf';
import SSPRegular from './en/SourceSansProRegular.ttf';

export const fontsMixin = css`
  /* zh */
  @font-face {
    font-family: Main;
    font-style: normal;
    font-weight: 300;
    unicode-range: U+4E00-9FFF, U+2B740-2B81F;
    src: url(${NotoSansSCWoff2}) format('woff2'),
      url(${NotoSansSCWoff}) format('woff');
  }
  @font-face {
    font-family: Main;
    font-style: normal;
    font-weight: 400;
    unicode-range: U+4E00-9FFF, U+2B740-2B81F;
    src: url(${NotoSansSCWoff2}) format('woff2'),
      url(${NotoSansSCWoff}) format('woff');
  }
  @font-face {
    font-family: Main;
    font-style: italic;
    font-weight: 400;
    unicode-range: U+4E00-9FFF, U+2B740-2B81F;
    src: url(${NotoSansSCWoff2}) format('woff2'),
      url(${NotoSansSCWoff}) format('woff');
  }
  @font-face {
    font-family: Main;
    font-style: normal;
    font-weight: 700;
    unicode-range: U+4E00-9FFF, U+2B740-2B81F;
    src: url(${NotoSansSCBoldWoff2}) format('woff2'),
      url(${NotoSansSCBoldWoff}) format('woff');
  }

  /* en */
  @font-face {
    font-weight: 200;
    font-family: Main;
    font-style: normal;
    src: local('Source Sans Pro ExtraLight'), local('SourceSansPro-ExtraLight'),
      url(${SSPExtraLight}) format('truetype');
  }

  @font-face {
    font-weight: 300;
    font-family: Main;
    font-style: normal;
    src: local('Source Sans Pro Light'), local('SourceSansPro-Light'),
      url(${SSPLight}) format('truetype');
  }

  @font-face {
    font-weight: 400;
    font-family: Main;
    font-style: normal;
    src: local('Source Sans Pro'), local('SourceSansPro-Regular'),
      url(${SSPRegular}) format('truetype');
  }

  @font-face {
    font-weight: 700;
    font-family: Main;
    font-style: normal;
    src: local('Source Sans Pro Bold'), local('SourceSansPro-Bold'),
      url(${SSPBold}) format('truetype');
  }

  @font-face {
    font-weight: 400;
    font-family: Main;
    font-style: italic;
    src: local('Source Sans Pro Italic'), local('SourceSansPro-It'),
      url(${SSPItalic}) format('truetype');
  }
`;
